/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Table_Auto_SyncInputs */

const es_settings_dirs_table_auto_sync = /** @type {(inputs: Settings_Dirs_Table_Auto_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización`)
};

const en_settings_dirs_table_auto_sync = /** @type {(inputs: Settings_Dirs_Table_Auto_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-sync`)
};

/**
* | output |
* | --- |
* | "Auto-sync" |
*
* @param {Settings_Dirs_Table_Auto_SyncInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_table_auto_sync = /** @type {((inputs?: Settings_Dirs_Table_Auto_SyncInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Table_Auto_SyncInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_table_auto_sync(inputs)
	return en_settings_dirs_table_auto_sync(inputs)
});
export { settings_dirs_table_auto_sync as "settings.dirs.table.auto_sync" }